import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { HeartHandshake } from "lucide-react";
import { DONATE_MESSAGE } from "@/data/site";
import { cn } from "@/lib/utils";

// Donate = "Coming Soon" behaviour everywhere. Never links to a payment processor.
export const DonateButton = ({ className, size, withIcon = false, label = "Donate", ...props }) => {
  const handleClick = () => {
    toast("Online donations coming soon", {
      description: DONATE_MESSAGE,
      duration: 6000,
    });
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      size={size}
      data-testid="donate-button"
      className={cn(
        "rounded-full bg-rda-teal text-white hover:bg-rda-tealDark transition-colors font-semibold",
        className
      )}
      {...props}
    >
      {withIcon && <HeartHandshake className="mr-2 h-4 w-4" />}
      {label}
    </Button>
  );
};
